import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {OrderSummaryContainer} from '../../../../../features/OrderSummary/OrderSummaryContainer'
import {
  selectActiveOption,
  selectProposalInfo,
  updateOption,
} from '../../../../../app-store/ProposalSlice'
import {useProductsCatalog} from '../hooks/useProductsCatalog'
import {useProposalPaymentPreview} from '../hooks/useProposalPaymentPreview'

export function OrderSummary({onPreviewLoadingChange}) {
  const dispatch = useDispatch()
  const activeOption = useSelector(selectActiveOption)
  const {thryvId} = useSelector(selectProposalInfo)
  const {
    selectedCountry,
    selectedProducts,
    handleRemoveProduct,
    isNewTLMCAccessible,
    isNewCustomer,
  } = useProductsCatalog()
  const {refreshPaymentPreview} = useProposalPaymentPreview()

  return (
    <OrderSummaryContainer
      activeItem={activeOption}
      currentId={activeOption?.displayOrder ?? null}
      idFallback="proposal"
      thryvId={thryvId}
      selectedCountry={selectedCountry}
      selectedProducts={selectedProducts}
      handleRemoveProduct={handleRemoveProduct}
      isNewTLMCAccessible={isNewTLMCAccessible}
      isNewCustomer={isNewCustomer}
      refreshPaymentPreview={refreshPaymentPreview}
      onUpdateItem={(displayOrder, changes) =>
        dispatch(updateOption({displayOrder, changes}))
      }
      onPreviewLoadingChange={onPreviewLoadingChange}
    />
  )
}
